export const PAGE_RANGE_DISPLAYED = 2;
export const MARGIN_PAGES_DISPLAYED = 2;
export const BREAK_LABEL = '...';
